var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"py-4 ma-auto"},[_c('apexchart',{ref:"realTimeBarChart",attrs:{"type":"bar","height":"237","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }